export default __webpack_public_path__ + "static/media/wealth-g.4b26c9e7.png";